import React from 'react';

import { FixedFooter } from '@components';

import { useFixedFooterHelper } from './fixedFooter.helper';

export interface FixedFooterPlaceholderProps {
	onSubmitCorporateForm?: () => void;
}

export const FixedFooterPlaceholder: React.FC<FixedFooterPlaceholderProps> = ({ onSubmitCorporateForm }) => {
	const { fixedFooterProps } = useFixedFooterHelper({ onSubmitCorporateForm });

	return <FixedFooter {...fixedFooterProps} />;
};
